import { render, staticRenderFns } from "./Poster.vue?vue&type=template&id=00189cf2&scoped=true&"
import script from "./Poster.vue?vue&type=script&lang=js&"
export * from "./Poster.vue?vue&type=script&lang=js&"
import style0 from "./Poster.vue?vue&type=style&index=0&id=00189cf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00189cf2",
  null
  
)

export default component.exports